import Vue from 'vue'
import VueI18n from 'vue-i18n'
import zh from './language/zh'
import en from './language/en'
import App from './App.vue'
import router from './router'

Vue.use(VueI18n);
const i18n = new VueI18n({
  locale: localStorage.getItem('languageSet') || 'zh', // 从 localStorage 获取用户选择的语言，没有则默认中文
  messages: {
    'zh': zh,
    'en': en
  }
})
router.afterEach((to, from, next) => {
  window.scrollTo(0, 0);
});
Vue.config.productionTip = false
new Vue({
  render: h => h(App),
  router,
  i18n
}).$mount('#app')

